// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import store from './store/index'
import '@/puConfig'
import VueAxios from 'vue-axios'
import axios from 'axios'
import { request } from '@/library/axios';
import $ from '@/assets/js/jquery'
import '@/assets/css/ui.css'
import "@/assets/css/iconfont/iconfont.css"
import '@/components/main.css'
import vConsole from 'vconsole'
//幻灯片
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)
//时间选择
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)

import exif from 'exif-js' //用于获取拍摄图片的基本信息（例如：拍摄方向）
Vue.config.productionTip = false
Vue.prototype.EXIF = exif;

Vue.config.productionTip = false

//请求
Vue.prototype.$request = request;

/**
 * 添加插件
*/
// Vue.use(dateTime)
Vue.use(VueAxios, axios);
//用于调试在手机端可以使用控制器
// var vconsole = new vConsole();
// Vue.use(VueCookies);
window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue() // 使用集中的事件处理器
  }
})


// WEBPACK FOOTER //
// ./src/main.js